import React from 'react';
import { useQuery } from '@apollo/client';
import { ErrorContainer } from 'components/organisms/Error/ErrorContainer';
import { LoadingContainer } from 'components/molecules/Loaders/LoadingContainer';
import { useLocation } from 'react-router-dom';
import FIND_MY_COMMANDE from '../../graphql/query/shop/findMyCommande.query';
import { FindMyCommandeQuery } from '../../graphql/generated/graphql';
import PublicShopRecapCommandeView from './PublicShopRecapCommande.view';
import usePublicShop from '../../hooks/usePublicShop';

const PublicShopRecapCommande = () => {
  const { classeId } = usePublicShop();
  const location = useLocation<{ search: string }>();
  const params = new URLSearchParams(location.search);
  const { data, error, loading } = useQuery<FindMyCommandeQuery>(
    FIND_MY_COMMANDE,
    {
      variables: {
        id: params.get('id'),
        numerocommande: params.get('numerocommande'),
        classeId: classeId
      }
    }
  );
  if (error)
    return (
      <ErrorContainer text={'Impossible de trouver la commande recherchée'} />
    );
  if (loading) return <LoadingContainer />;

  return <PublicShopRecapCommandeView recapCommande={data.findMyCommande} />;
};
export default PublicShopRecapCommande;
